// @flow

import React from 'react';

const NewsIcon = () => {
    const display = (
        <span>
            &nbsp;
            <i
                className={'far fa-newspaper'}
                style={{ color: 'goldenrod', paddingRight: '3px' }}
                title="Click to see recent News"
            />
        </span>
    );

    return display;
};

export default NewsIcon;



// WEBPACK FOOTER //
// ./src/components/UI/NewsIcon.js